/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  teamIdentifier: ZodTypes.Team.Identifier,
  userId: ZodTypes.Id,
});

export const DeleteTeamUser = {
  id: 'team-user.delete',
  tag: 'Team',
  summary: 'Remove team user',
  description: 'Remove a member from an organization team',
  method: 'delete',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/team/${params.teamIdentifier}/user/${params.userId}`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: { 'application/json': { schema: z.string().optional() } },
    },
  },
} as const satisfies Endpoint;
